import { APIConfiguration } from '@savgroup-front-common/configuration';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  Model,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.catalog}models/${COMMON_QUERY_PARAMS.MODEL_ID}`;

export interface GetRepairableByModelIdPayload {
  modelId: string;
}

export const getModelByIdRequest = (
  payload: GetRepairableByModelIdPayload,
): ApiRequestDescriptor => ({
  url: ENDPOINT.replace(COMMON_QUERY_PARAMS.MODEL_ID, payload.modelId),
  config: { method: SUPPORTED_METHODS.GET },
});

async function getModelByIdQuery(
  payload: GetRepairableByModelIdPayload,
): Promise<BackResponse<Model> | BackResponseFailure> {
  try {
    return await executeQuery<BackResponse<Model>>(
      getModelByIdRequest(payload),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
}

export default getModelByIdQuery;
